<template>
  <transition name="fade">
    <div v-show="showScrollTop" @click="ToTop" class="iconfont icon-ziyuanldpi go-top"></div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      showScrollTop: false
    }
  },
  props: {
    distenceToShow: {
      type: Number,
      default: 500
    }
  },
  methods: {
    ToTop (e) {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.ToTop)
        window.scrollTo(0, currentScroll - (currentScroll / 18))
      }
    },
    compatiable () {
      window.requestAnimFrame = (function () {
        return window.requestAnimationFrame ||
             window.webkitRequestAnimationFrame ||
             window.mozRequestAnimationFrame ||
            function (callback) {
              window.setTimeout(callback, 6000 / 60)
            }
      })()
    },
    showButton (e) {
      e = e || window.event
      if (document.documentElement.scrollTop >= this.distenceToShow) {
      	this.showScrollTop = true
      } else {
      	this.showScrollTop = false
      }
    }

  },
  mounted () {
    this.compatiable()
    window.addEventListener('scroll', this.showButton)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.showButton)
  }
}
</script>
<style lang="scss">
$blue: #00a8ff;
$circleSize: 3.625rem;
.go-top {
  position: fixed;
  bottom: 3.9375rem;
  right: 1.4375rem;
  z-index: 10;
  font-size: 2.8125rem;
  line-height: $circleSize;
  height: $circleSize;
  width: $circleSize;
  cursor: pointer;
  color: #b0b0b0;
  border-radius: 50%;
  border: 0.1875rem solid #b0b0b0;
  text-align: center;
  &:hover {
    background-color: $blue;
    border-color: $blue;
    color: #fff;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  opacity: .5;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ButtonToTop.vue